import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { Day, OrderingCalendarComponent } from '../ordering-calendar/ordering-calendar.component';
import { DeferService } from '../../../core/services/ordering/defer.service';
import { DateTime } from 'luxon';
import { OpenCloseTime } from '../../../core/models/open-close-time.model';
import { GenericObject } from '../../../core/models/core/generic-object';

@Component({
  selector: 'cwo-date-time-picker',
  standalone: true,
  imports: [CommonModule, OrderingCalendarComponent],
  templateUrl: './date-time-picker.component.html',
  styleUrl: './date-time-picker.component.scss',
})
export class DateTimePickerComponent {
  deferService = inject(DeferService);
  deferDateInput = input<DateTime>();
  deferredDayTimes = input<GenericObject<OpenCloseTime | undefined> | undefined>();
  selectedDateClosed = false;

  readonly defferedDateTimeUpdate = output<DateTime>();
  readonly storeClosedForSelectedDate = output<boolean>();


  handleSelectedDate(date: Day) {
    this.selectedDateClosed = date.closed;
    const dateTime = DateTime.fromISO(date.date);
    const updatedDate = this.deferDateInput()?.set({
      day: dateTime.day,
      month: dateTime.month,
      year: dateTime.year,
      second: 0,
      millisecond: 0,
    });
    this.defferedDateTimeUpdate.emit(updatedDate ?? dateTime);
  }

}
